import { useEffect } from "react";
import { useBillingMetadata } from "../hooks/useBillingMetadata";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router";
import { Calendar } from "../../SharedModule/components/Calendar";
import { selectRecurringOptions } from "../redux/reducers/metaBilling.reducer";
import "../../styles/main.module.scss";
import { FiltersSelect } from "../components/ProcessBillableItems/AdvancedFiltersSelect";
import {
  setItem,
  resetFiltersRecurring as resetFiltersAction,
  selectRecurringFilters,
  setupRecurring,
} from "../redux/reducers/filters.reducer";
import { clear as clearBillableHours } from "../redux/reducers/billableHours.reducer";
import { clearBillableItems } from "../redux/reducers/billableItems.reducer";
import {
  ROUTE_BILLABLE_ITEMS_RESULTS,
  ROUTE_RECURRING_QUERY,
} from "../../SharedModule/utils/constants";
import { setActiveTab } from "../../SharedModule/redux/reducers/uiShared.reducer";
import Footer from "../../SharedModule/components/Footer";
import { selectUserRoles } from "../../SharedModule/redux/reducers/auth.reducer";
import { Spinner } from "../../SharedModule/components/Spinner";
import { ForbiddenPage } from "../../SharedModule/pages/ForbiddenPage";
import { billingOwners } from "../../SharedModule/utils/accessUtils";

export const RecurringQuery = () => {
  useBillingMetadata();
  const dispatch = useDispatch();
  const recurringOptions = useSelector(selectRecurringOptions);
  const filtersState = useSelector(selectRecurringFilters);
  const location = useLocation();
  const navigate = useNavigate();
  const { userRolesList, rolesLoaded } = useSelector(selectUserRoles);

  useEffect(() => {
    document.title = "The Hub - Process Recurring Billing";
  }, []);

  useEffect(() => {
    if (location.hash !== "#keep") {
      dispatch(setupRecurring());
    }
    dispatch(clearBillableHours());
    dispatch(clearBillableItems());

    dispatch(setActiveTab(ROUTE_RECURRING_QUERY));
  }, [location.hash, dispatch]);

  const resetFilters = (event: any) => {
    event.preventDefault();
    dispatch(resetFiltersAction());
  };

  const runQuery = async (event: any) => {
    event.preventDefault();
    navigate(ROUTE_BILLABLE_ITEMS_RESULTS);
  };

  return (
    <>
      {!rolesLoaded && (
        <Spinner
          style={{
            marginLeft: "50%",
            marginTop: "5%",
          }}
        />
      )}

      {rolesLoaded && !billingOwners(userRolesList) && <ForbiddenPage />}

      {rolesLoaded && billingOwners(userRolesList) && (
        <div className="content">
          <div className="content-header" style={{ marginTop: "0" }}>
            <h2>Process Recurring Billing</h2>
          </div>
          <form className="card invoice-summary-background p-4 mt-3">
            <div className="row justify-content-center">
              <label htmlFor="posting-date" className="col-sm-3 col-form-label">
                Posting Date
              </label>
              <div className="col-sm-5">
                <div className="d-flex">
                  <div className="position-relative">
                    <Calendar
                      id="posting-date"
                      date={filtersState.postingDate}
                      onChange={(date: string) =>
                        dispatch(setItem({ postingDate: date.toString() }))
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
            <FiltersSelect
              className="row justify-content-center mt-4"
              label="Billing cycles"
              options={recurringOptions.billingCycles}
              value={filtersState.billingCycles}
              isLoading={!recurringOptions.billingCycles}
              onChange={(billingCycles) => {
                dispatch(setItem({ billingCycles }));
              }}
            />
            <FiltersSelect
              className="row justify-content-center mt-4"
              label="Clients"
              options={recurringOptions.clients}
              value={filtersState.clients}
              isLoading={!recurringOptions.loaded}
              onChange={(clients: any) => dispatch(setItem({ clients }))}
            />
            <hr className="separator" />
            <div className="footer-filter mt-4">
              <div
                className="link-text"
                role="button"
                tabIndex={0}
                onClick={resetFilters}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    resetFilters(e);
                  }
                }}
              >
                Reset Filters
              </div>
              <button className="btn btn-primary" onClick={runQuery}>
                Run Query
              </button>
            </div>
          </form>
          <Footer />
        </div>
      )}
    </>
  );
};
